import React, { FC } from 'react';

type PlayAudioIconProps = {
  className?: string;
};

export const PlayAudioIcon: FC<PlayAudioIconProps> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M5 17.3356V6.66894C5 5.78937 5 5.3491 5.18509 5.08886C5.34664 4.86172 5.59564 4.7126 5.87207 4.67694C6.18868 4.63611 6.57701 4.84321 7.35254 5.25683L17.3525 10.5902L17.3562 10.5918C18.2132 11.0489 18.642 11.2775 18.7826 11.5823C18.9053 11.8481 18.9053 12.155 18.7826 12.4209C18.6418 12.7261 18.212 12.9557 17.3525 13.4141L7.35254 18.7474C6.57645 19.1613 6.1888 19.3676 5.87207 19.3268C5.59564 19.2911 5.34664 19.142 5.18509 18.9149C5 18.6546 5 18.2152 5 17.3356Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PlayAudioIcon;

